import { render, staticRenderFns } from "./resources-detail.component.html?vue&type=template&id=8fd6402c&scoped=true&"
import script from "./resources-detail.component.ts?vue&type=script&lang=ts&"
export * from "./resources-detail.component.ts?vue&type=script&lang=ts&"
import style0 from "./resources-detail.component.scss?vue&type=style&index=0&id=8fd6402c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd6402c",
  null
  
)

export default component.exports